// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8vzmn","loader":"styles_loader__9lJ2A","rotate":"styles_rotate__sKSKT","prixClipFix":"styles_prixClipFix__M7z0u"};